import InputHeader from "../input/InputHeader";
import ReactSelect, { createFilter } from "react-select";
import styles from "./Dropdowns.module.css";
import { customStyle, customStyleLight } from "./CustomStyle";
import InputCard from "../containers/InputCard";
import ThemeContext, { themes } from "../../context/ThemeContext";
import { useContext } from "react";

const CrewTypeSelect = ({
  identifier,
  value,
  selectHandler,
  required = false,
}) => {
  const themeCtx = useContext(ThemeContext);
  let options = [
    { value: "AERIAL", label: "AERIAL" },
    { value: "CABLE PULLING", label: "CABLE PULLING" },
    { value: "DIRECTIONAL DRILL", label: "DIRECTIONAL DRILL" },
    { value: "FIBER SPLICING", label: "FIBER SPLICING" },
    { value: "JOINT TRENCH", label: "JOINT TRENCH" },
    { value: "MICROTRENCHING", label: "MICROTRENCHING" },
    { value: "MISSLE", label: "MISSLE" },
  ];

  let dropdownStyle =
    themeCtx.currentTheme() === themes.light ? customStyleLight : customStyle;

  return (
    <InputCard>
      <>
        <InputHeader text="Crew Type" required={required} />
        <ReactSelect
          className={styles.dropdown}
          value={value}
          onChange={selectHandler}
          options={options}
          filterOption={createFilter({ ignoreAccents: false })}
          styles={dropdownStyle}
          name={identifier}
          id={identifier}
        />
      </>
    </InputCard>
  );
};

export default CrewTypeSelect;
